const APP_ICON_NAME = 'eholdings';

export default APP_ICON_NAME;
